interface Props {
  readonly className?: string;
}

export default function ParadexLogoText(props: Props) {
  const { className } = props;

  return (
    <svg
      className={className}
      width="125"
      height="17"
      viewBox="0 0 125 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5176 3.38305C11.0253 2.57282 10.324 1.94772 9.41356 1.50775C8.50095 1.06778 7.4446 0.849976 6.24231 0.849976H0V3.52027H6.31854C7.13313 3.53334 7.76913 3.78382 8.23087 4.26735C8.69262 4.75087 8.9235 5.38469 8.9235 6.16879C8.9235 6.92893 8.6948 7.51483 8.23741 7.92648C7.77784 8.33595 7.11353 8.54069 6.24231 8.54069H0V16.85H3.29758V11.211H6.18786C8.08494 11.211 9.57038 10.7601 10.6442 9.85406C11.7158 8.95017 12.2537 7.71303 12.2537 6.14483C12.2537 5.11243 12.0076 4.19111 11.5176 3.38305Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.7231 0.849976H21.6673L15.7103 16.85H19.2105L23.1898 4.89245L23.1919 4.89898L23.1941 4.89245L25.2066 10.8821H25.1979L26.0931 13.5524H26.0953L27.2061 16.85H30.7106L24.7231 0.849976Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.7065 10.1568C46.667 9.72555 47.3836 9.14401 47.8562 8.41436C48.3289 7.68689 48.5641 6.77647 48.5641 5.68526C48.5641 4.14537 48.0523 2.95616 47.0264 2.11325C46.0005 1.27034 44.5434 0.849976 42.6529 0.849976H36.7068V3.52027H42.6725C43.5502 3.52245 44.1993 3.73808 44.624 4.16716C45.0531 4.60059 45.2687 5.19302 45.2687 5.9488C45.2687 5.97276 45.2687 5.9989 45.2665 6.02286V6.08602C45.2687 6.11434 45.2687 6.14047 45.2687 6.16879C45.2687 6.92893 45.0378 7.51483 44.5805 7.92648C44.1231 8.33595 43.4588 8.54069 42.5854 8.54069H36.7068V16.85H40.0044V10.991H42.6311L45.6303 16.85H49.1696V16.6953L45.7065 10.1568Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.2311 0.849976H60.1753L54.2205 16.85H57.725L61.7043 4.89245L63.7147 10.8821H63.7125L65.7141 16.85H69.2208L63.2311 0.849976Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.5124 4.50258C85.8895 3.33514 85.0248 2.43342 83.914 1.79961C82.8053 1.16579 81.5464 0.849976 80.1394 0.849976H75.217V3.52027H80.1394C81.4353 3.52027 82.422 3.93846 83.095 4.77701C83.7702 5.61556 84.1056 6.84834 84.1056 8.47535V9.32261C84.0926 10.8886 83.7441 12.0953 83.0623 12.9382C82.3806 13.7789 81.3961 14.2015 80.1067 14.2015H75.217V16.85H80.1721C81.5726 16.8413 82.8271 16.5189 83.9423 15.8829C85.0553 15.2447 85.9178 14.3474 86.5298 13.1908C87.1418 12.0321 87.4468 10.71 87.4468 9.22242V8.48624C87.4468 6.99863 87.1353 5.67219 86.5124 4.50258Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.3447 9.86931H101.713V7.36019H94.3447V9.86931ZM94.3447 16.85H105.069V14.2015H94.3447V16.85ZM94.3447 3.52027H105.048V0.849976H94.3447V3.52027Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.362 8.78246L124.023 0.849976H120.231L117.232 6.36481L114.23 0.849976H110.438L115.099 8.78246L110.319 16.85H114.154L117.232 11.2458L120.307 16.85H124.143L119.362 8.78246Z"
        fill="white"
      />
    </svg>
  );
}
